


// 普通用户
 const USR = [
    {
        "pagePath": "/pages/home/home",
        "title": "首页",
        "index": 0,
        "icon": "home-capsule",
        "activeIcon": "home-capsule-fill"
    },
    {
        "index": 1,
        "pagePath": "/pages/user/user",
        "title": "我的",
        "icon": "my",
        "activeIcon": "my-fill"
    }

]

// 工程师
 const GCS = [
     {
         "pagePath": "/pages/home/home",
         "title": "首页",
         "index": 0,
         "icon": "home-capsule",
         "activeIcon": "home-capsule-fill"
     },
     {
         "pagePath": "/pages/chat/chat",
         "title": "消息",
         index: 1,
         "icon": "message",
         "activeIcon": "message-fill"
     },
     {
         "index": 2,
         "pagePath": "/pages/assignment/assignment",
         "title": "任务",
         "icon": "order",
         "activeIcon": "order-fill"
     },
     {
         "index": 3,
         "pagePath": "/pages/user/user",
         "title": "我的",
         "icon": "my",
         "activeIcon": "my-fill"
     }

 ]

// 合伙人
 const HHR = [
    {
        "pagePath": "/pages/home/home",
        "title": "首页",
        index: 0,
        "icon": "home-capsule",
        "activeIcon": "home-capsule-fill"
    },
    {
        "pagePath": "/pages/chat/chat",
        "title": "消息",
        index: 1,
        "icon": "message",
        "activeIcon": "message-fill"
    },
    {
        "pagePath": "/pages/user/user",
        "title": "我的",
        index: 2,
        "icon": "my",
        "activeIcon": "my-fill"
    }
]

// 服务站
 const FWZ = [
    {
        "pagePath": "/pages/home/home",
        "title": "首页",
        index: 0,
        "icon": "home-capsule",
        "activeIcon": "home-capsule-fill"
    },
    {
        "pagePath": "/pages/chat/chat",
        "title": "消息",
        index: 1,
        "icon": "message",
        "activeIcon": "message-fill"
    },
    {
        "pagePath": "/pages/user/user",
        "title": "我的",
        index: 2,
        "icon": "my",
        "activeIcon": "my-fill"
    }
]

// 个人用户
 const GRU = [
    {
        "pagePath": "/pages/home/home",
        "title": "首页",
        index: 0,
        "icon": "home-capsule",
        "activeIcon": "home-capsule-fill"
    },
    {
        "pagePath": "/pages/chat/chat",
        "title": "消息",
        index: 1,
        "icon": "message",
        "activeIcon": "message-fill"
    },{
        "pagePath": "/pages/order/order",
        "title": "订单",
        index: 2,
         "icon": "shopbag",
         "activeIcon": "shopbag-fill"

    },
    {
        "pagePath": "/pages/user/user",
        "title": "我的",
        index: 3,
        "icon": "my",
        "activeIcon": "my-fill"
    }
]

// 机构用户
 const JGU = [
    {
        "pagePath": "/pages/home/home",
        "title": "首页",
        index: 0,
        "icon": "home-capsule",
        "activeIcon": "home-capsule-fill"
    },
    {
        "pagePath": "/pages/chat/chat",
        "title": "消息",
        index: 1,
        "icon": "message",
        "activeIcon": "message-fill"
    },
    {
        "pagePath": "/pages/user/user",
        "title": "我的",
        index: 2,
        "icon": "my",
        "activeIcon": "my-fill"
    }
]


export default [
    [],
    [],
    USR, // 普通用户
    GCS, // 固证工程师
    HHR, // 申请合伙人
    FWZ, // 固证服务站
    GRU, // 个人消费者
    JGU // 机构消费者
];


